'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContactThumbnail = require('./ContactThumbnail');

var _ContactThumbnail2 = _interopRequireDefault(_ContactThumbnail);

var _StaticAmount = require('./StaticAmount');

var _StaticAmount2 = _interopRequireDefault(_StaticAmount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecipientHeader = function RecipientHeader(_ref) {
	var thumbnailUrl = _ref.thumbnailUrl;
	var Header = _ref.Header;
	var currencySymbol = _ref.currencySymbol;
	var amount = _ref.amount;
	var currencyCode = _ref.currencyCode;
	var textColor = _ref.textColor;

	return _react2.default.createElement(
		'div',
		null,
		_react2.default.createElement(_ContactThumbnail2.default, { thumbnailUrl: thumbnailUrl }),
		_react2.default.createElement(
			'h3',
			{ className: 'vx_text-3_lighter', style: { marginBottom: 10, color: textColor } },
			Header
		),
		_react2.default.createElement(_StaticAmount2.default, { currencySymbol: currencySymbol, amount: amount, currencyCode: currencyCode, textColor: textColor })
	);
};

RecipientHeader.propTypes = {
	thumbnailUrl: _react.PropTypes.string,
	Header: _react.PropTypes.element.isRequired,
	currencySymbol: _react.PropTypes.string.isRequired,
	amount: _react.PropTypes.string.isRequired,
	currencyCode: _react.PropTypes.string.isRequired,
	textColor: _react.PropTypes.string
};

exports.default = RecipientHeader;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** /jobvolume/donatenodeweb-ci-9488/workspace/Release/~/guest-payment/dist/components/RecipientHeader.js
 ** module id = 329
 ** module chunks = 6
 **/